import React from 'react';
import styled from 'styled-components';
import { SOUTH_KOREA_LEVEL_MAX } from '@/constants';
import TrackingService from '@/services/tracking';
import { Icongraphy } from '@design-system/pc';
import { KakaoMapProps } from './KakaoMap';

interface MapButtonsProps extends Pick<KakaoMapProps, 'level' | 'setLevel'> {
  handleClickCurrentLoactionButton: () => void;
}

const MapButtons = ({
  level,
  setLevel,
  handleClickCurrentLoactionButton,
}: MapButtonsProps) => {
  const levelHandler = (state: 'plus' | 'minus') => {
    if (state === 'minus') {
      if (level !== SOUTH_KOREA_LEVEL_MAX) {
        setLevel(level + 1);
      }
    } else {
      if (level !== 1) {
        setLevel(level - 1);
      }
    }
  };

  return (
    <Container {...TrackingService.tagGTM('shop_search')}>
      <ButtonBox
        onClick={handleClickCurrentLoactionButton}
        {...TrackingService.tagGTM('shop_search_location_button')}
      >
        <Icongraphy variant="ic_my_location" size={32} />
      </ButtonBox>
      <ButtonContainer>
        <ZoomIconBox
          onClick={() => levelHandler('plus')}
          {...TrackingService.tagGTM('shop_search_zoom_plus_button')}
        >
          <Icongraphy variant="ic_plus_bold" size={32} />
        </ZoomIconBox>
        <ZoomIconBox
          onClick={() => levelHandler('minus')}
          {...TrackingService.tagGTM('shop_search_zoom_minus_button')}
        >
          <Icongraphy variant="ic_minus_bold" size={32} />
        </ZoomIconBox>
      </ButtonContainer>
    </Container>
  );
};

export default MapButtons;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 40px;
  right: 24px;
  z-index: 9999;
  gap: 16px;
  justify-content: center;
`;

const ButtonBox = styled.div`
  border-radius: 4px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.natural_color.white};
  border: 1px solid ${({ theme }) => theme.colors.natural_color.gray[200]};
`;

const ButtonContainer = styled.div`
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  width: 48px;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.natural_color.gray[200]};
`;

const ZoomIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme.colors.natural_color.white};
  padding: 8px;
  cursor: pointer;
  :last-child {
    border-top: 1px solid ${({ theme }) => theme.colors.natural_color.gray[200]};
  }
`;
